export type ComponentConditionValues = {
	Name: ComponentConditionKey;
	Id: string;
};
export enum ConditionABCD {
	A = "A",
	B = "B",
	C = "C",
	D = "D",
}
export enum ConditionAC {
	A = "A",
	C = "C",
}
export enum ConditionNoYes {
	No = "No",
	Yes = "Yes",
}
export enum ConditionYesNo {
	Yes = "Yes",
	No = "No",
}
export enum ConditionCosmetic {
	LikeNew = "Like New",
	Scratches = "Scratches",
	Cracks = "Cracks",
}
export enum ConditionFaultyWorking {
	Working = "Working",
	Faulty = "Faulty",
}
export enum ConditionBlurryDots {
	Working = "Working",
	BlurryDots = "Blurry/Dots",
	Faulty = "Faulty",
}
export enum ConditionMaterial {
	Titanium = "Titanium",
	Aluminum = "Aluminum",
	Stainless = "Stainless",
}
export enum ConditionOverall {
	Good = "Good",
	Poor = "Poor",
	Faulty = "Faulty",
}

export enum GenericCondition {
	Optimal = "Optimal",
	Average = "Average",
	Worst = "Worst",
}

export type ComponentConditionKey =
	| ConditionABCD
	| ConditionAC
	| ConditionNoYes
	| ConditionYesNo
	| ConditionCosmetic
	| ConditionFaultyWorking
	| ConditionBlurryDots
	| ConditionMaterial
	| ConditionOverall;

export type ComponentConditionType =
	| typeof ConditionABCD
	| typeof ConditionAC
	| typeof ConditionNoYes
	| typeof ConditionYesNo
	| typeof ConditionCosmetic
	| typeof ConditionFaultyWorking
	| typeof ConditionBlurryDots
	| typeof ConditionMaterial
	| typeof ConditionOverall;
